export default __webpack_public_path__ + "static/media/smiley-icon.a35e4237.svg";